import React, { useEffect, useRef, useState } from "react";
import { useDebounce } from "../../../../hooks/useDebounce";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { organizationTeamList } from "../../../../services/organizationService";
import { useParams } from "react-router-dom";
import useClickOutside from "../../../../hooks/useClickOutside";
import Image from "../../../elements/Image";
import Card from "../../../elements/Card";
import Search from "../../../form/Search";
import ArtistItem from "./ArtistItem";
import { useTranslation } from "react-i18next";

const Artists = ({
  values = {},
  handleChange = () => {},
  formValidate = () => {},
  setFieldsValue = () => {},
  errors,
  data,
}) => {
  const { t } = useTranslation();
  const divRef = useRef(null);
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [filters, setFilters] = useState({
    limit: 30,
    page: 1,
    sortQuery: "-createdAt",
  });
  const { eventId } = useParams();
  const [readOnly, setReadOnly] = useState(false);

  useClickOutside(divRef, () => {
    if (eventId) {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
  });

  useEffect(() => {
    if (eventId) {
      setReadOnly(true);
    }
  }, [eventId]);

  const {
    data: artist,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["artist", filters, search, data?.artistData],
    queryFn: async () => {
      const res = await organizationTeamList({
        ...filters,
        ...(search && { keyword: search }),
        type: "artist-verification",
        status: "active",
      });
      const filtered_artists = res?.docs?.data
        ?.map((item) =>
          (data?.artistData || [])?.some((elm) => elm?._id === item?._id)
            ? false
            : item
        )
        ?.filter(Boolean);

      return {
        ...res?.docs,
        data: [...(data?.artistData || []), ...(filtered_artists || [])],
      };
    },
  });

  return (
    <div
      ref={divRef}
      onClick={() => {
        if (eventId) {
          setReadOnly(false);
        }
      }}
    >
      <Card
        title={t("Artists")}
        bodyclassName={"space-y-6"}
        className={" py-4 md:py-8 px-3 md:px-6"}
      >
        <div className="mb-8 flex justify-end w-full md:w-auto">
          <Search
            divClasses={"w-full md:w-60"}
            search={setKeyword}
            searchValue={keyword}
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {artist?.data?.map((item, i) => (
            <ArtistItem
              key={i?.toString()}
              artist={item}
              selectedArtists={values?.artists || []}
              onSubmit={(val) => {
                if ((values?.artists || [])?.some((id) => val?.id === id)) {
                  // setFieldsValue({
                  //   artists: values?.artists?.fillter(
                  //     (elm) => elm?.id !== item?.user
                  //   ),
                  // });
                  setFieldsValue({
                    artists: (values?.artists || [])?.filter(
                      (id) => id !== val?.id
                    ),
                  });
                } else {
                  setFieldsValue({ artists: [...values?.artists, val?.id] });
                }
              }}
            />
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Artists;
